import React from 'react';
import PropTypes from 'prop-types';

const CompareTableHeadItem = ({ title }) => (
  <th className='bra-comparsionTable__cell'>
    <p className='bra-comparsionTable__title'>{title}</p>
  </th>
);

CompareTableHeadItem.propTypes = {
  title: PropTypes.string.isRequired,
};

export default CompareTableHeadItem;
